module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"IM90S Dashboard","short_name":"IM90S","start_url":"/app/home","background_color":"#0F4C5C","theme_color":"#0F4C5C","display":"minimal-ui","icon":"src/components/images/logos/logo.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
